module.exports = "<div class=\"main-section\">\n  <alg-attivazioni-step *ngIf=\"attivazione.webStatus==='step1'\" [step]=\"steps[0]\"></alg-attivazioni-step>\n  <alg-attivazioni-step *ngIf=\"attivazione.webStatus==='step2'\" [step]=\"steps[1]\"></alg-attivazioni-step>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/alg-attivazioni/alg-attivazioni-steps/alg-attivazioni-steps.component.html
// module id = ./src/app/components/alg-attivazioni/alg-attivazioni-steps/alg-attivazioni-steps.component.html
// module chunks = main